<form [formGroup]="forgotPasswordForm" class="hero-form-forgot-password d-flex flex-column" (ngSubmit)="send()">
  <input class="hero-input-text" type="text" formControlName="email" dictionary="placeholder_email" placeholder="Deine email" />
  <div class="additional d-flex justify-content-end">
    <a class="hero-link" routerLink="/sign-in" dictionary="sign_in_2">Anmelden?</a>
  </div>
  <button class="btn btn-hero btn-hero-primary" type="submit" [disabled]="disabled" dictionary="submit">Absenden</button>
</form>
